import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "0 0.5rem",
    width: "100%",
  },
  button: {
    color: "#91c241",
    borderColor: "#91c241",
    backgroundColor: "#f7ffeb",
    width: "100%",
  },
  buttonDisabled: {
    color: "#818181",
    width: "100%",
  },
}));

export default function ButtonGroups(props) {
  const {
    switchMode,
    handleSwitchMode,
    firstButton,
    secondButton,
    disabled,
  } = props;

  const classes = useStyles();

  return (
    <ButtonGroup
      aria-label="outlined primary button group"
      className={classes.root}
    >
      <Button
        className={
          switchMode == "simple" ? classes.button : classes.buttonDisabled
        }
        onClick={() => {
          handleSwitchMode("simple");
        }}
        disabled={disabled}
      >
        {firstButton}
      </Button>
      <Button
        className={
          switchMode == "expert" ? classes.button : classes.buttonDisabled
        }
        onClick={() => {
          handleSwitchMode("expert");
        }}
        disabled={disabled}
      >
        {secondButton}
      </Button>
    </ButtonGroup>
  );
}

ButtonGroups.propTypes = {
  inputTitle: PropTypes.any,
};
